import { authFetch } from './base';
export const setConnectionAudioSourceDevice = (eventId, connectionId, deviceId) => {
    void authFetch(`api/events/${eventId}/connections/${connectionId}/audio-source-device`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ deviceId }),
    }).catch((err) => console.error('Failed to set audio source device:', err));
};
export const setEventAudioSource = (eventId, connectionId) => {
    void authFetch(`api/events/${eventId}/audio-source`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ connectionId }),
    }).catch((err) => console.error('Failed to set event audio source:', err));
};
export const setEventAudioMuted = (eventId, muted) => {
    void authFetch(`api/events/${eventId}/audio-mute`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ muted }),
    }).catch((err) => console.error('Failed to set event audio mute:', err));
};
